import { BrandEnum } from "../_common/enum/brand.enum";
import { ARCS_HIGHLIGHT_COLOR, ARCS_PRIMARY_COLOR, ARCS_PULSE_COLOR, ARCS_SECONDARY_COLOR } from "../_const/brandColors/arcs.color.const";
//import { HELLO_HIGHLIGHT_COLOR, HELLO_PRIMARY_COLOR, HELLO_PRIMARY_LIGHT_COLOR, HELLO_PULSE_COLOR, HELLO_SECONDARY_COLOR } from "../_const/brandColors/hello.color.const";
//import { LOW_HIGHLIGHT_COLOR, LOW_PRIMARY_COLOR, LOW_PRIMARY_LIGHT_COLOR, LOW_PULSE_COLOR, LOW_SECONDARY_COLOR } from "../_const/brandColors/low.color.const";
//import { LOWQUOTE_HIGHLIGHT_COLOR, LOWQUOTE_PRIMARY_COLOR, LOWQUOTE_PRIMARY_LIGHT_COLOR, LOWQUOTE_PULSE_COLOR, LOWQUOTE_SECONDARY_COLOR } from "../_const/brandColors/lowquote.color.const";
import { DAFFODILCARE_HIGHLIGHT_COLOR, DAFFODILCARE_PRIMARY_COLOR, DAFFODILCARE_PRIMARY_LIGHT_COLOR, DAFFODILCARE_PULSE_COLOR, DAFFODILCARE_SECONDARY_COLOR } from "../_const/brandColors/daffodilCare.color.const";
import {
    MISTYCROFT_HIGHLIGHT_COLOR,
    MISTYCROFT_PRIMARY_COLOR,
    MISTYCROFT_PRIMARY_LIGHT_COLOR,
    MISTYCROFT_PULSE_COLOR,
    MISTYCROFT_SECONDARY_COLOR,
} from '../_const/brandColors/mistyCroft.color.const';
import DaffodilCareLogo from '../_assets/brandLogos/DaffodilCareLogos/Daffodil-Care-Logo.jpg';
import ArcLogo from '../_assets/brandLogos/ArcLogos/ARCS-logo.jpg';
import MistyCroftLogo from '../_assets/brandLogos/MistyCroftLogos/Misty-Croft-Logo.jpg';


export function getBrandPrimaryColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.DaffodilCare:
            return DAFFODILCARE_PRIMARY_COLOR;

        case BrandEnum.Arcs:
            return ARCS_PRIMARY_COLOR;

        case BrandEnum.MistyCroft:
            return MISTYCROFT_PRIMARY_COLOR;

        default:
            return DAFFODILCARE_PRIMARY_COLOR;
    }
}

export function getBrandSecondaryColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.DaffodilCare:
            return DAFFODILCARE_SECONDARY_COLOR;

        case BrandEnum.Arcs:
            return ARCS_SECONDARY_COLOR;

        case BrandEnum.MistyCroft:
            return MISTYCROFT_SECONDARY_COLOR;

        default:
            return DAFFODILCARE_SECONDARY_COLOR;
    }
}

export function getBrandVibrantColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.DaffodilCare:
            return DAFFODILCARE_PULSE_COLOR;

        case BrandEnum.Arcs:
            return ARCS_PULSE_COLOR;

        case BrandEnum.MistyCroft:
            return MISTYCROFT_PULSE_COLOR;

        default:
            return DAFFODILCARE_PULSE_COLOR;
    }
}

export function getBrandPrimaryLightColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.DaffodilCare:
            return DAFFODILCARE_PRIMARY_LIGHT_COLOR;

        case BrandEnum.Arcs:
            return ARCS_PRIMARY_COLOR;

        case BrandEnum.MistyCroft:
            return MISTYCROFT_PRIMARY_LIGHT_COLOR;

        default:
            return DAFFODILCARE_PRIMARY_LIGHT_COLOR;
    }
}

export function getBrandHighlightColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.DaffodilCare:
            return DAFFODILCARE_HIGHLIGHT_COLOR;

        case BrandEnum.Arcs:
            return ARCS_HIGHLIGHT_COLOR;

        case BrandEnum.MistyCroft:
            return MISTYCROFT_HIGHLIGHT_COLOR;

        default:
            return DAFFODILCARE_HIGHLIGHT_COLOR;
    }
}

export function getBrandFontFamily(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.DaffodilCare:
            return '"Tahoma", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        case BrandEnum.Arcs:
            return '"Tahoma", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        case BrandEnum.MistyCroft:
            return '"Tahoma", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        default:
            return '"Futura", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    }
}

//export function getBrandCallbackLink(brand: BrandEnum) {
//    switch (brand) {
//        case BrandEnum.DaffodilCareService:
//            return "https://lowquotes.ie/request-a-call-back/";
//        case BrandEnum.Low:
//            return "https://low.ie/get-a-consultation/";
//        case BrandEnum.Hello:
//            return "https://hello.ie/request-a-call-back/";
//        case BrandEnum.TrueWealth:
//            return "https://truewealth.ie/request-a-call-back/";
//        default:
//            return ""
//    }
//}

//export function getBrandPrivacyPolicyLink(brand: BrandEnum) {
//    switch (brand) {

//        case BrandEnum.DaffodilCareService:
//            return "https://lowquotes.ie/LQ-Terms-of-business.pdf";
//        case BrandEnum.Low:
//            return "https://low.ie/Low-Terms-of-business.pdf";
//        case BrandEnum.Hello:
//            return "https://hello.ie/LQ-Terms-of-business.pdf";
//        case BrandEnum.TrueWealth:
//            return "https://truewealth.ie/TW-Terms-of-business.pdf";
//        default:
//            return ""
//    }
//}

//export function getBrandHQCompletedLink(brand: BrandEnum) {
//    switch (brand) {

//        case BrandEnum.DaffodilCareService:
//            return "https://lowquotes.ie/thank-you-application";
//        case BrandEnum.Low:
//            return "https://low.ie/thank-you-application";
//        case BrandEnum.Hello:
//            return "https://hello.ie/thank-you-application";
//        case BrandEnum.TrueWealth:
//            return "https://truewealth.ie/thank-you-application";
//        default:
//            return ""
//    }
//}

export function getBrandLogoSymbol(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.DaffodilCare:
            return DaffodilCareLogo;

        case BrandEnum.Arcs:
            return ArcLogo;

        case BrandEnum.MistyCroft:
            return MistyCroftLogo;

        default:
            return DaffodilCareLogo;
    }
}

export const brandToFlagMap = {
/*    [BrandEnum.DaffodilCare]: "isUsingLowQuoteLogo",*/
    //[BrandEnum.Low]: "isUsingLowLogo",
    //[BrandEnum.Hello]: "isUsingHelloLogo",
    //[BrandEnum.TrueWealth]: "isUsingTrueWealthLogo",
} as const;

